module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("前端相关")]), _vm._v("\n  Vue.js官网："), _c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/",
      "target": "_blank"
    }
  }, [_vm._v("https://cn.vuejs.org/v2/guide/")]), _c('br'), _vm._v("\n  Elment-Ui官网："), _c('a', {
    attrs: {
      "href": "http://element-cn.eleme.io/#/zh-CN/",
      "target": "_blank"
    }
  }, [_vm._v("http://element-cn.eleme.io/#/zh-CN/")]), _c('br'), _vm._v("\n  Mint-Ui官网："), _c('a', {
    attrs: {
      "href": "http://mint-ui.github.io/#!/zh-cn",
      "target": "_blank"
    }
  }, [_vm._v("http://mint-ui.github.io/#!/zh-cn")]), _c('br'), _vm._v("   \n  JS菜鸟教程："), _c('a', {
    attrs: {
      "href": "http://www.runoob.com/js/js-intro.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.runoob.com/js/js-intro.html")]), _c('br'), _vm._v("\n  图表："), _c('a', {
    attrs: {
      "href": "http://blog.gdfengshuo.com/example/#/vue-schart",
      "target": "_blank"
    }
  }, [_vm._v("http://blog.gdfengshuo.com/example/#/vue-schart")]), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286b8ea4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Todo.vue
// module id = 1269
// module chunks = 1